<template>
  <Nav></Nav>
  <main class="organization-new">
    <back-button></back-button>
    <OrganizationEditor :edit="false"></OrganizationEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import OrganizationEditor from '@/components/OrganizationEditor.vue';

export default defineComponent({
  name: 'NewOrganization',
  components: {
    BackButton,
    Nav,
    OrganizationEditor,
  },
});
</script>